import Page from "..";

export default Page;
export { getServerSideProps } from "..";
